$(document).ready(function () {

    const megaMenuGridWrapper = $('.js-mega-menu-grid-wrapper');
    const megaMenuGridContent = $('.js-mega-menu-grid-content');
    if (megaMenuGridWrapper.length > 0 && megaMenuGridContent.length > 0) {
        megaMenuGridWrapper.html(megaMenuGridContent.html());
        megaMenuGridContent.html('');
    }


    $('.mega-menu').each(function () {
        var value = $(this).attr('data-parent-link');
        var toggle = $('.js-mega-menu-toggle-mobile[data-navlink-handle=' + value + ']');
        if (toggle.length > 0) {
            const clone = $(this).clone();
            clone.addClass('is-mobile')
            toggle.after(clone);

            toggle.addClass('has-children');

        }

    });

    function showMegaMenu() {
        $('body').addClass('is-show-mega-menu');
    }

    function hideMegaMenu() {
        if (!$('body').hasClass('is-quick-view-modal-show')) {
            $('.js-mega-menu-mobile-desktop').removeClass('is-active');
            $('body').removeClass('is-show-mega-menu');
            $('.js-mega-menu-navbar-item').removeClass('is-mega-menu-open');
            $('.js-mega-menu-navbar-toggle').removeClass('is-mega-menu-open');
        }
    }


    function showMegaNavBlock(menuLink, navItem) {
        $('.js-mega-menu-navbar-toggle').removeClass('is-mega-menu-open');
        navItem.addClass('is-mega-menu-open');
        $('.mega-menu.clone').removeClass('is-active');
        // $('.mega-menu[data-parent-link=' + menuLink + ']').css("top", getHeaderHeight());
        $('.mega-menu[data-parent-link=' + menuLink + ']').addClass('is-active');
        showMegaMenu();
    }

    function showMegaNavBlockMob(menuLink, navItem) {
        $('.js-mega-menu-navbar-toggle').removeClass('is-mega-menu-open');
        $('.mega-menu-mob__toggle').removeClass('is-open');
        navItem.addClass('is-mega-menu-open');
        $('.mega-menu.clone').removeClass('is-show');
        $('.mega-menu[data-parent-link=' + menuLink + ']').addClass('is-show');
        showMegaMenu();
    }


    $('.js-mega-menu-mobile-desktop, .js-mega-menu-navbar-toggle').on('mouseleave', function () {
        hideMegaMenu();
    });
    $('.js-mega-menu-navbar-toggle').each(function () {
        var navItem = $(this);
        var linkAttr = $(this).attr('data-navlink-handle');
        var menu = $('.mega-menu[data-parent-link=' + linkAttr + ']')
        if (menu.length > 0) {
            $('.js-mega-menu-navbar-toggle', this).attr('href', '#').on('click', function (e) {
                e.preventDefault();
            });

            $(this).append('<svg role="presentation" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '<path d="M11 6L6 2L1 6" stroke="black" stroke-width="2" stroke-linecap="round"/>' +
                '</svg>');
            $(this).addClass('has-children');

            $(this).on('click touchstart mouseover', function () {
                var navItem = $(this);
                showMegaNavBlock(linkAttr, navItem);
            });
            $(menu).on('mouseover', function () {
                showMegaNavBlock(linkAttr, navItem);
            });
        }
    });


    $('.js-mega-menu-filter-btn').on('click', function (e) {
        e.preventDefault();
        const value = $(this).attr('data-value');
        const parentEl = $(this).parents('.js-mega-menu-grid-wrapper');
        const products = parentEl.find('.mega-menu__slide');
        parentEl.find('.js-mega-menu-filter-btn.is-active').removeClass('is-active');
        products.each(function () {
            if ($(this)[0].hasAttribute('data-value')) {
                const filters = $(this).attr('data-value').split(',');
                if (filters.includes(value)) {
                    $(this).removeClass('is-hidden');
                } else {
                    $(this).addClass('is-hidden');
                }
            }
        });
        $(this).addClass('is-active');
    });
});